// extracted by mini-css-extract-plugin
export default {"main":"footer_main__LWNNx","body":"footer_body__j78Gj","legal":"footer_legal__97K-1","legal_links":"footer_legal_links__Qnga-","socials":"footer_socials__d38Gf"};